import React, { createContext, useState, useEffect, useContext } from 'react';
import Api from '../api';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    // Saat app dimuat, cek apakah ada sesi aktif via cookie
    const initializeAuth = async () => {
      try {
        await checkUserSession();
      } catch (error) {
        console.error('Error initializing auth:', error);
        setLoading(false);
      }
    };

    initializeAuth();
  }, []);

  const checkUserSession = async () => {
    try {
      setLoading(true);
      // Cookie HTTP-only dikirim otomatis oleh browser (withCredentials: true di Api)
      const response = await Api.get('/current-user');
      setCurrentUser(response.data.data);
      setLoading(false);
    } catch (error) {
      // Jika 401/403, berarti tidak ada sesi aktif — ini normal
      console.error('Session check failed:', error);
      setCurrentUser(null);
      setLoading(false);
    }
  };

  const login = async (email, password, rememberMe) => {
    try {
      setLoading(true);
      setError('');
      const response = await Api.post('/login', { email, password });
      // Backend akan set HTTP-only cookie secara otomatis
      // Response hanya berisi data user (bukan token)
      const user = response.data.data?.user || response.data.data;

      if (rememberMe) {
        localStorage.setItem('rememberedUsername', email);
      } else {
        localStorage.removeItem('rememberedUsername');
      }

      setLoading(false);
      return { success: true, user, setUser: () => setCurrentUser(user) };
    } catch (error) {
      setLoading(false);
      const errorMessage = error.response?.data?.message || 'Login gagal. Silakan coba lagi.';
      setError(errorMessage);
      return { success: false, error: errorMessage };
    }
  };

  const logout = async () => {
    try {
      // Panggil endpoint logout agar server menghapus HTTP-only cookie
      await Api.post('/logout');
    } catch (error) {
      console.error('Logout request failed:', error);
    } finally {
      setCurrentUser(null);
    }
  };

  const value = {
    currentUser,
    loading,
    error,
    login,
    logout,
    checkUserSession
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
